import google from "../../../../../images/LandingPageImage/google.png";
import Ornament from "../../../../../images/LandingPageImage/Ornament.svg";

import Navbar from "../../common/Navbar";
import about from "../../../../../images/LandingPageImage/send_bulk_message_about_us.webp";
import FAQContactSection from "../FAQContactSection";
import CallToAction from "../CallToAction";
import React, { useContext } from "react";
import MyContext from "../../../../../MyContext";
import { Link } from "react-router-dom";

export default function About() {
  const { openFreeTrialModal } = useContext(MyContext);

  return (
    <div>
      <div
        className="hero-bg pt-4 pt-md-5 overflow-hidden font-inter"
        style={{ minHeight: "90vh" }}
      >
        <Navbar />

        <div className="container mt-4 mt-lg-5 mb-5">
          <div className="row align-items-center justify-content-center">
            <div className="col-12 col-lg-6 px-3 px-md-4 order-2 order-lg-1 text-center text-lg-start mt-4 mt-lg-0">
              <h1 className="display-6 display-md-5 fw-semibold font-bricolage mb-4 lh-sm text-white">
                How to make businesses smarter using{" "}
                <br className="d-none d-md-block" />
                <span style={{ color: "yellowgreen" }}>
                  {" "}
                  WhatsApp Marketing
                </span>
              </h1>

              <div className="mx-auto mx-lg-0" style={{ maxWidth: "600px" }}>
                <p className="small text-light opacity-90 mb-3 fw-light lh-lg">
                  We are at SendBulkMsg and we assist small and medium
                  businesses in expanding at an efficient level by transforming
                  the mode through which they communicate with customers via
                  WhatsApp marketing. In the digital-first world where speed and
                  relevance are vital, pertinent conversations are to be had to
                  develop trust, loyalty and long-term expansion.
                </p>
                <p className="small text-light opacity-90 mb-3 fw-light lh-lg">
                  We are a trusted WhatsApp marketing firm in India because we
                  allow companies to access customers on the platform that they
                  are using on a daily basis. Our solutions are concerned with
                  being simple, scaling and getting customer engagement faster,
                  smarter, and more impactful.
                </p>
                <p className="small text-light opacity-90 mb-4 fw-light lh-lg">
                  SendBulkMsg is a full out WhatsApp marketing application built
                  on the official WhatsApp Business API, enabling real-time
                  conversations that are customized and automated.
                </p>
              </div>

              <div className="d-flex flex-column flex-sm-row justify-content-center justify-content-lg-start gap-3 mt-4">
                 <Link to="/login" className="text-decoration-none">
                <button
                  type="button"
                  className="btn btn-outline-google rounded-pill fw-semibold d-flex align-items-center justify-content-center gap-2 px-4 py-2"
                  style={{ minHeight: "46px" }}
                >
                  <span
                    className="rounded-circle bg-white d-flex align-items-center justify-content-center"
                    style={{ width: "26px", height: "26px" }}
                  >
                    <img src={google} alt="Google" style={{ width: "14px" }} />
                  </span>
                  <span className="text-nowrap">Start With Google</span>
                </button>
                </Link>
                <button
                  onClick={openFreeTrialModal}
                  className="btn btn-outline-demo rounded-pill px-4 py-2 fw-semibold d-flex align-items-center justify-content-center"
                >
                  Book a Demo
                </button>
              </div>
             
            </div>

            <div className="col-12 col-lg-6 mb-5 mb-lg-0 order-2 order-lg-2">
              <div className="position-relative d-flex align-items-center justify-content-center p-2 p-md-3">
                <img
                  src={Ornament}
                  className="img-fluid floating-animation"
                  alt="Background"
                  style={{ opacity: "0.4", filter: "blur(20px)", width: "85%" }}
                />

                <img
                  src={about}
                  alt="whatsapp_marketing"
                  className="position-absolute img-fluid main-image-hover"
                  style={{
                    maxWidth: "85%",
                    height: "auto",
                    zIndex: 2,
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <style jsx>{`
          /* Mobile handling for display font */
          @media (max-width: 768px) {
            .display-6 {
              font-size: 1.8rem !important;
            }
          }

          .main-image-hover {
            transition: transform 0.4s ease-out;
          }

          .main-image-hover:hover {
            transform: translateY(-10px) scale(1.02);
          }

          @keyframes float {
            0%,
            100% {
              transform: translateY(0);
            }
            50% {
              transform: translateY(-15px);
            }
          }

          .floating-animation {
            animation: float 5s ease-in-out infinite;
          }
        `}</style>
      </div>
      <section className="min-vh-100 d-flex who-bg align-items-center font-inter py-5 px-3">
        <div className="container max-w-4xl mx-auto text-center">
          <h2 className="display-6 fw-bold font-bricolage text-white mb-4">
            Who We Are
          </h2>

          <div className="mb-5 px-md-5">
            <p className="fs-6 opacity-90 mb-4 fw-light lh-lg text-yellowgreen">
              We are a trusted WhatsApp marketing firm in India because we allow
              companies to access customers on the platform that they are using
              on a daily basis. Our solutions are concerned with being simple,
              scaling and getting customer engagement faster, smarter, and more
              impactful.
            </p>
            <p className="fs-6 opacity-90 fw-light lh-lg text-yellowgreen">
              SendBulkMessage, also known as SendBulkMsg, is a full out WhatsApp
              marketing application that is built on the official WhatsApp
              Business API and it enables businesses to engage in real time
              conversations with their customers that are customized and
              automated. Whether it is in terms of customer support and
              notifications, or lead engagement and even promotions, our
              platform will allow sending bulk messages with a personal touch.
            </p>
          </div>

          <div className="row g-4 mt-2">
            <div className="col-12 col-md-6">
              <div
                className="glass-card h-100 p-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg"
                style={{
                  background:
                    "linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))",
                }}
              >
                <h3 className="h4 fw-bold mb-3 text-yellowgreen font-bricolage">
                  Our Vision
                </h3>
                <p className="text-white opacity-75 fw-light">
                  To invest in small and medium-sized companies in the ability
                  to establish more long-term customer relationships and ensure
                  sustainable growth based on smart, meaningful WhatsApp
                  marketing experiences.
                </p>
              </div>
            </div>

            <div className="col-12 col-md-6">
              <div
                className="glass-card h-100 p-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg"
                style={{
                  background:
                    "linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))",
                }}
              >
                <h3 className="h4 fw-bold mb-3 text-yellowgreen font-bricolage">
                  Our Mission
                </h3>
                <p className="text-white opacity-75 fw-light">
                  We aim to make business communication easy by offering an
                  effective WhatsApp marketing platform that allows interacting
                  with customers faster, more personal and efficiently without
                  complexities and intensive technical work.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="min-vh-100 d-flex wedo-bg align-items-center font-inter py-4 py-md-5 px-2 px-md-3 overflow-hidden">
        <div className="container-fluid container-lg mx-auto text-center">
          <h2 className="display-6 display-md-5 fw-bold font-bricolage text-white mb-3 mb-md-4">
            What We Do
          </h2>

          <div className="mx-auto" style={{ maxWidth: "900px" }}>
            <p className="fs-6 fs-md-5 opacity-90 mb-4 mb-md-5 fw-light lh-lg text-yellowgreen px-2 px-md-0">
              SendBulkMsg is a marketing agency-style WhatsApp end-to-end
              solution that is wholly based on developing a growing business. We
              assist businesses in simplifying the communication and expand the
              engagement with automation and intelligent workflows.
            </p>

            <div
              className="row g-3 g-md-0 rounded-4 overflow-hidden  mx-1 mx-md-0"
              style={{
                background:
                  "linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))",
              }}
            >
              <div className="col-12 col-md-6 border-bottom border-md-bottom-0 border-md-end border-light border-opacity-10">
                <div className="p-4 p-lg-5 text-start h-100">
                  <ul className="list-unstyled mb-0 custom-bullets">
                    <li className="text-white opacity-90 fw-light mb-3 d-flex align-items-start gap-2">
                      <span className="text-yellowgreen">▹</span>
                      Personalize the use of WhatsApp marketing to send
                      notifications, alerts, and updates.
                    </li>
                    <li className="text-white opacity-90 fw-light mb-3 d-flex align-items-start gap-2">
                      <span className="text-yellowgreen">▹</span>
                      WhatsApp Wholesale and bulk messaging campaigns are easily
                      and securely delivered.
                    </li>
                    <li className="text-white opacity-90 mb-3 fw-light d-flex align-items-start gap-2">
                      <span className="text-yellowgreen">▹</span>
                      Converse with all customers in a team inbox.
                    </li>
                    <li className="text-white opacity-90 fw-light mb-3 d-flex align-items-start gap-2">
                      <span className="text-yellowgreen">▹</span>
                      Automate responses with no-codes and low-codes.
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="p-4 p-lg-5 text-start h-100">
                  <ul className="list-unstyled mb-0 custom-bullets">
                    <li className="text-white opacity-90 fw-light mb-3 d-flex align-items-start gap-2">
                      <span className="text-yellowgreen">▹</span>
                      Route is the smartest chat that can be tagged and
                      arranged.
                    </li>
                    <li className="text-white opacity-90 fw-light d-flex mb-3        align-items-start jus gap-2">
                      <span className="text-yellowgreen">▹</span>
                      Measure performance in real time using actionable insights
                      and analytics.
                    </li>
                    <li className="text-white opacity-90 fw-light mb-3 d-flex align-items-start gap-2">
                      <span className="text-yellowgreen">▹</span>
                      Through automation, teamwork and analytics, SendBulkMsg
                      assists businesses to save their time, work smarter and
                      provide better customer experiences.
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <p className="fs-6 opacity-90 mt-4 mt-md-5 fw-light lh-lg text-yellowgreen px-2 px-md-0">
              Through automation, teamwork and analytics, SendBulkMsg assists
              businesses to save their time, work smarter and provide better
              customer experiences.
            </p>
          </div>
        </div>

        <style>{`
  @media (max-width: 768px) {
    .display-6 {
      font-size: 1.8rem !important;
    }
  }

  .main-image-hover {
    transition: transform 0.4s ease-out;
  }

  .main-image-hover:hover {
    transform: translateY(-10px) scale(1.02);
  }

  @keyframes float {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-15px);
    }
  }

  .floating-animation {
    animation: float 5s ease-in-out infinite;
  }
`}</style>

      </section>
      <FAQContactSection />
      <CallToAction />
    </div>
  );
}
